import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';


import { teamKeys } from './keys.js';
import {
  addTeamMember,
  createTeam,
  deleteTeam,
  fetchTeam,
  fetchTeams,
  lookupGithubUser,
  removeTeamMember,
} from './teams.js';

import { apiClient } from '@/lib/api.js';

export function useTeams() {
  return useQuery({ queryKey: teamKeys.list(), queryFn: () => fetchTeams(apiClient) });
}

export function useTeam(uuid) {
  return useQuery({
    queryKey: teamKeys.detail(uuid),
    queryFn: () => fetchTeam(uuid, apiClient),
    enabled: Boolean(uuid),
  });
}

export function useCreateTeam() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (vars) => createTeam(vars, apiClient),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: teamKeys.all }),
  });
}

export function useDeleteTeam() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (uuid) => deleteTeam(uuid, apiClient),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: teamKeys.all }),
  });
}

export function useLookupGithubUser() {
  return useMutation({
    mutationFn: (vars) => lookupGithubUser(vars, apiClient),
  });
}

export function useAddTeamMember(teamUuid) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (vars) => addTeamMember({ teamUuid, ...vars }, apiClient),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: teamKeys.detail(teamUuid) }),
  });
}

export function useRemoveTeamMember(teamUuid) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (memberUuid) => removeTeamMember({ teamUuid, memberUuid }, apiClient),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: teamKeys.detail(teamUuid) }),
  });
}
